import translationalTeamApi from "../../api/translationalTeams";

const state = {
  translationalTeam: {}
};

const getters = {};

const actions = {
  getTranslationalTeam(context, translationalTeamId) {
    translationalTeamApi
      .getTranslationalTeam(translationalTeamId)
      .then(function(response) {
        context.commit("updateTranslationalTeam", response.data);
      })
      .catch(function(error) {
        console.log(error);
      });
  }
};

const mutations = {
  updateTranslationalTeam(state, value) {
    state.translationalTeam = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
